export const categories = [
  {
    id: 'tech',
    name: '科技数码',
    slug: 'tech',
    icon: 'ri-smartphone-line',
    description: '前沿科技资讯与数码产品深度评测，带你掌握数字时代的脉搏',
    articleCount: 128,
  },
  {
    id: 'life',
    name: '生活随笔',
    slug: 'life',
    icon: 'ri-heart-line',
    description: '记录生活点滴，分享人生态度，感受文字的温度与力量',
    articleCount: 256,
  },
  {
    id: 'culture',
    name: '文化艺术',
    slug: 'culture',
    icon: 'ri-palette-line',
    description: '跨越时空的对话，探索文学、电影、音乐与艺术的无限可能',
    articleCount: 89,
  },
  {
    id: 'career',
    name: '职场成长',
    slug: 'career',
    icon: 'ri-briefcase-line',
    description: '职场经验、技能提升与个人成长，助你在职场中脱颖而出',
    articleCount: 167,
  },
  {
    id: 'travel',
    name: '旅行故事',
    slug: 'travel',
    icon: 'ri-road-map-line',
    description: '用脚步丈量世界，用镜头定格瞬间，每一段旅程都是独一无二的故事',
    articleCount: 94,
  },
  {
    id: 'food',
    name: '美食探店',
    slug: 'food',
    icon: 'ri-restaurant-line',
    description: '舌尖上的城市探索，寻找隐藏在街头巷尾的美味佳肴',
    articleCount: 73,
  },
  {
    id: 'health',
    name: '健康养生',
    slug: 'health',
    icon: 'ri-psychotherapy-line',
    description: '科学养生，健康生活，让身体与心灵都保持最佳状态',
    articleCount: 141,
  },
  {
    id: 'education',
    name: '教育学习',
    slug: 'education',
    icon: 'ri-book-open-line',
    description: '学习资源、教育理念、考试攻略，知识改变命运从这里开始',
    articleCount: 205,
  },
];